import { TokenUsageLogs } from "./../models/usageLog";
import { ApiResponse } from "../models/apiResponse";
import { apiBaseUrl, checkSession } from "./authService";

export const fetchUsageLog = async (
  nextPageToken: string
): Promise<TokenUsageLogs> => {
  try {
    const session = await checkSession(); // 세션을 가져옵니다.
    const accessToken = session?.access_token; // 액세스 토큰을 가져옵니다

    if (!accessToken) {
      throw new Error("No access token found");
    }

    const response = await fetch(
      `${apiBaseUrl}/admin/v1/usageLog?nextPageToken=${nextPageToken}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // Authorization 헤더에 액세스 토큰 추가
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch token data");
    }

    const result: ApiResponse<TokenUsageLogs> = await response.json();

    return result.result;
  } catch (error: any) {
    throw new Error(
      error.message || "An error occurred while fetching token data"
    );
  }
};
